import i18nFactory from '@yandex-int/i18n';

import {
    GroupsEditMassActionGroup,
    GroupsEditMassActionItem,
    GroupsEditMassActionItems,
    GroupsEditMassActionItemType
} from '../../typings/groups';

import * as keyset from './GroupsMassActionsHelpers.i18n';

const i18n = i18nFactory(keyset);

export const getGroupsEditMassActions = (): GroupsEditMassActionItems => {
    return getVisibleGroupsEditMassActions(getGroupsEditMassActionsItems());
};

export const getVisibleGroupsEditMassActions = (groupedItems: GroupsEditMassActionItems): GroupsEditMassActionItems => {
    return groupedItems.reduce(
        (acc: GroupsEditMassActionItems, next: GroupsEditMassActionGroup) => {
            const availableItems = next.items.filter((val: GroupsEditMassActionItem) => !val.disabled && !val.hidden);
            const visibleItems = next.items.filter((val: GroupsEditMassActionItem) => !val.hidden);

            if (availableItems.length !== 0) {
                acc.push({
                    title: next.title,
                    items: visibleItems
                });
            }

            return acc;
        },
        [] as GroupsEditMassActionItems
    );
};

export const getGroupsEditMassActionsItems = (): GroupsEditMassActionItems => {
    return [
        {
            title: '',
            items: [
                {
                    type: GroupsEditMassActionItemType.minusPhrase,
                    text: i18n('minus-phrase-list'),
                    val: GroupsEditMassActionItemType.minusPhrase,
                    hidden: false
                }
            ]
        }
    ];
};
